exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".system-overview{display:flex;padding:30px 25px;box-sizing:border-box;flex-wrap:wrap}\n", ""]);

// exports
